<p-overlayPanel #roadInfoPanel [appendTo]="'body'">

  <div class="flex flex-column gap-3 min-w-18rem">
    <div *ngIf="road as selectedRoad">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-map-marker"></i>
        <span class="text-lg font-semibold">{{ selectedRoad.text }}</span>
      </div>

      <div class="flex flex-column text-sm">
        <span *ngIf="selectedRoad.startDirection || selectedRoad.endDirection">
          {{ selectedRoad.startDirection || '-' }} &rarr; {{ selectedRoad.endDirection || '-' }}
        </span>
      </div>

      <div class="flex flex-column text-sm">
        <span><b>Carretera:</b> {{ selectedRoad.roadCode }}</span>
        <span><b>Sentido:</b> {{ mapDirectionCodeToText(selectedRoad.directionCode!) }}</span>
      </div>

      <div class="flex flex-column gap-1 text-sm">
        <span><b>Tramo:</b> {{
          selectedRoad.directionCode === 'S'
            ? (selectedRoad.endKm) + ' km -> ' + (selectedRoad.startKm) + ' km'
            : (selectedRoad.startKm) + ' km -> ' +  (selectedRoad.endKm) + ' km'
        }}
        </span>
        <span><b>Longitud:</b> {{ selectedRoad.length }} km</span>
      </div>
    </div>

    <div *ngIf="roles.length > 0" class="flex flex-column gap-2 text-sm">

      <div class="flex align-items-center gap-2">
        <i class="pi pi-user"></i>
        <span class="text-lg font-semibold">Permisos</span>
      </div>
      
      <div class="flex flex-wrap gap-2">
        <span *ngFor="let role of roles"
          class="px-2 py-1 border-round font-semibold"
          [ngClass]="getRoleBadgeClasses(role)" >
          {{ getRoleLabel(role) }}
        </span>
      </div>
    </div>

  </div>
</p-overlayPanel>
